<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h5 class="header title"> <i class="fa fa-cogs"></i><b> Manage Permit & Document Type Links</b></h5>

    </div>

  </div>

  <div class="row selectpermit">
    <div class="col-md-2 flex-center">
      <label id="idCtype" class="control-label selectpermittype"><strong>Select Permit Type : </strong></label>
    </div>
    <div class="col-md-5 flex-center" style="padding: 0px;">
      <select class="form-control col-md-2" id="idCtype" [(ngModel)]="selectedPermitType" (change)="onChange()">
        <ng-container *ngFor="let cat of permits">
          <option [ngValue]="cat" *ngIf="cat.is_active">
            <div>{{cat.code}} - {{cat.description}}</div>
          </option>
        </ng-container>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-md-2 flex-center">
      <label id="idCtype" class="control-label selectpermittype"><strong>Description : </strong></label>
    </div>
    <div class="col-md-5 flex-center" style="padding: 0;">
      <textarea class="form-control col-md-4 input-s" placeholder="Description" [(ngModel)]="description"></textarea>
    </div>
  </div>
  <div class="col-12 action" style="padding: 0px;">
    <app-actions (actionEvent)="doPermitTypeDocAction($event)" [actions]="documentLinkDelinkAction"></app-actions>
  </div>
  <div class="row" style="padding: 20px 0;">

    <div class="col-md-6" style="padding: 10px 0;">
      <strong>This left pane shows all the available document types that can still be linked to the selected permit
        type. </strong>
    </div>
    <div class="col-md-6" style="padding: 10px 0;">
      <strong>This right-side pane shows all the document types that are already linked and therefore shown on the
        uploads screen. </strong>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6" style="padding:0px 0;">
      <div class="row">
        <div class="col-12">
          <div class="tableFixHead">
            <table class="table">
              <thead>
                <th>Select</th>
                <th class="tblhead">Code</th>
                <th class="tblhead descriptionlink">Description</th>
              </thead>
              <tbody>
                <tr *ngFor="let x of doctypes.unlinked;let index = index">
                  <td><input type="checkbox" value="{{x.id}}" [ngModel]="selectedUnLinkIndex  === index"
                      (change)="checkedPermitDocUnlink($event,x.id,x,index)"></td>
                  <td class="tblbody">
                    {{x.code}}
                  </td>
                  <td class="tblbody">
                    {{x.description}}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="doctypes.unlinked?.length == 0">
                  <td colspan="4" class="rm-brd">
                    <span class="text-info text-small">No Data found.</span>
                  </td>
                </tr>
              </tfoot>

            </table>
          </div>
        </div>

      </div>

    </div>

    <div class="col-md-6" style="padding:0px 0;">
      <div class="row">
        <div class="col-12">
          <div class="tableFixHead">
            <table class="table">
              <thead>
                <th></th>
                <th class="tblhead">Code</th>
                <th class="tblhead description">Description</th>
                <th class="tblhead border-right">Mandatory?</th>
              </thead>
              <tbody>
                <tr *ngFor="let x of doctypes.PermitLinked;let index = index">
                  <td><input type="checkbox" value="{{x.id}}" [ngModel]="selectedLinkIndex  === index"
                      (change)="checkedPermitDocLink($event,x.id,x,index)"></td>
                  <td class="tblbody">
                    {{x.code}}
                  </td>
                  <td class="tblbody">
                    {{x.description}}
                  </td>
                  <td class="tblbody border-right">
                    <input type="checkbox" [(ngModel)]="x.is_mandatory" (click)="onUpdateLink($event,x.id,x)">
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="doctypes.PermitLinked?.length == 0">
                  <td colspan="4" class="rm-brd">
                    <span class="text-info text-small">No Data found.</span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>

    </div>
  </div>
  <app-busy [message]="message" style="z-index:20000;position:relative;" *ngIf="isActivated"></app-busy>

  <!-- <div class="col-md-12">
    <br>
    <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/home']" class="btn btn-md btn-info pull-right"
      style="width:10%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Back</button>
    <br>
    <br>
    <br>
  </div> -->
</div>
<div class="col-md-12">
  <br>
  <div class="cover-x pull-right">
    <div class="main-btn rounded-circle rmp-all" [routerLink]="['/home']" title="Close"
      style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
      <span class="fa fa-times fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
    </div>
    <!-- <div class="lbl-app" style="margin: 1px auto;">
      <span>Close</span>
    </div> -->
  </div>
  <br>
  <br>
  <br>
</div>